var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 42,
    viewBox: "0 0 23 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 22.5C23 31.6127 23 39 11.5 39C0 39 0 31.6127 0 22.5C0 13.3873 5.14873 6 11.5 6C17.8513 6 23 13.3873 23 22.5Z",
    fill: "#F74542"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2496 19C19.2496 24.197 18.3001 26.9573 16.9557 28.4323C15.6383 29.8776 13.791 30.25 11.4996 30.25C9.2142 30.25 7.4973 29.8801 6.24125 28.4438C4.94129 26.9572 3.99706 24.1791 3.74873 18.9643C3.51108 13.9736 5.51493 11.2032 7.52018 9.65634C8.53828 8.87095 9.5747 8.38858 10.358 8.10309C10.7486 7.96072 11.0731 7.86844 11.2964 7.8124C11.3763 7.79236 11.443 7.77699 11.495 7.76565C11.5423 7.77664 11.6021 7.79124 11.6729 7.80999C11.8828 7.86554 12.1892 7.95724 12.5599 8.09898C13.3027 8.38301 14.2938 8.86418 15.2832 9.64983C17.236 11.2006 19.2496 13.9876 19.2496 19Z",
    fill: "#F74542",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 40H14C14 41.1046 13.1046 42 12 42H11C9.89543 42 9 41.1046 9 40Z",
    fill: "#F74542"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5L10 5L10 1.5C10 0.671573 10.6716 2.7328e-07 11.5 3.45703e-07C12.3284 4.18126e-07 13 0.671573 13 1.5L13 5Z",
    fill: "#F74542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image1.20b9278480f64d58b562f06bcca596b0.svg";
export { ForwardRef as ReactComponent };